import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <h1>Check out our work</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/img-19.jpg'
              text='Check out Our Amazing Products'
              label='Crafts'
              path='/services'
            />
            <CardItem
              src='images/img-18.jpg'
              text='Check out Our Amazing Products'
              label='Luxury'
              path='/services'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/img-17.jpg'
              text='Check out Our Amazing Products'
              label='Crafts'
              path='/services'
            />
            <CardItem
              src='images/img-16.jpg'
              text='Check out Our Amazing Products'
              label='Crafts'
              path='/products'
            />
            <CardItem
              src='images/img-15.jpg'
              text='Check out Our Amazing Products'
              label='Crafts'
              path='/sign-up'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
